export enum AuroraHeatPumpStatus {
  ON = 'on',
  OFF = 'off'
}

export default AuroraHeatPumpStatus
